module.exports = __webpack_public_path__ + "img/far fa-hospital Copy.d0a17d83.svg";